import React from 'react';
import {
    Show,
    TextField,
    DateField,
    FunctionField,
    TopToolbar,
} from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';
import {Card, CardContent, Typography} from "@material-ui/core";
import ContractStatuses from "../helper/ContractStatuses";
import ContractRequestDetailsButton from "../component/ContractRequestDetailsButton";
import ContractContentWidgetDialog from "../component/ContractContentWidgetDialog";

const useStyles = makeStyles((theme) => ({
    separator: {
        width: '10px',
        clear: 'none'
    }
}));

const cardStyle = {
    width: "100%",
    margin: '0.5em',
    padding: '0.5em',
    display: 'inline-block',
    verticalAlign: 'top',
    fontSize: '1.25rem',
    fontFamily: '"Roboto", "Helvetica", "Arial", "sans-serif"',
    fontWeight: 500,
    lineHeight: '1.6',
    letterSpacing: '0.0075em'
};
const rowStyle = {
    margin: '0',
    lineHeight: '30px',
    padding: "3px 0",
    fontFamily: '"Roboto", "Helvetica", "Arial", "sans-serif"',
};
const labelStyle = {
    display: 'inline-block',
    width: 200,
    fontSize: '1rem',
    fontWeight: 500,
    fontFamily: '"Roboto", "Helvetica", "Arial", "sans-serif"',
    color: 'gray'
};

const programs = {
    '63c1f32f-c8f4-4f5b-81a9-79b8452d6545': 'Серцево-судинні та цереброваскулярні захворювання, цукровий діабет 2-го типу та хронічні хвороби нижніх дихальних шляхів',
    '8a11c513-e7a9-4800-9fb9-becb743e08c4': 'Імуносупресивні лікарські засоби',
    '14e19712-b443-4391-b0f7-aba8e8662459': 'Нецукровий діабет',
    'f217889f-736f-462c-8f8b-ed99edddb3be': 'Розлади психіки та поведінки',
    '9d94a21b-ec70-4b91-946a-981f4db8d2b9': 'Епілепсія',
    '9a1364d7-2c61-4fe8-b889-ea788dbb7467': 'Інсуліни з доплатою',
    '9994be00-47b4-4969-800e-87a767751b47': 'Інсуліни безоплатно',
    'e9c6beeb-b19f-4b97-b42a-020c5c996c56': 'Інсуліни аналоги (з доплатою)',
    '7335a30e-61f2-42b0-9ed4-2afe847bba16': 'Інсуліни аналоги (безоплатно)',
    'cda113e4-b8dd-4ec4-a878-3d1c7eae49da': 'Інсуліни людські (флакони безоплатно)',
    '857588d8-9e12-4935-96c4-b08e95d19dce': 'Інсуліни людські (картриджи та шприцручки з доплатою)',
    '8efe29df-18bd-4d49-8995-c3f7e44d9e12': 'Інсуліни людські (картриджи та шприцручки безоплатно)',
    '5562904e-100f-11ee-be56-0242ac120002': 'Опіоїдні анальгетики',
    '9723a9a0-100a-11ee-be56-0242ac120002': 'Опіоїдні анальгетики для лікування РПП',
    '0cefbce3-6dd2-45bd-b1e6-983fc055d5e0': 'Медичні вироби для визначення рівня глюкози в крові',
    '786ac2aa-af37-4bd0-b1f5-40a017bf2237': 'Постанова КМУ №1380 від 03.12.2024'
};

const ContractRequestShow = props => {
    const ContractRequestShowTitle = ({ record }) => {
        return <span>Договір: {record ?`${record.id}` : ''}</span>;
    };

    const Label = (prop) => {
        return (
            <span style={labelStyle}>{prop.caption}: </span>
        );
    }

    const ContractActions = ({ basePath, data, resource }) => {
        return (
            <TopToolbar>
                {typeof data !== 'undefined' && data.contractNumber ?
                    <ContractContentWidgetDialog {...props} contractNumber={data.contractRequestId}/>
                    : null}
            </TopToolbar>
        );
    };

    const contractsValues = {
        NEW: "Договір створений",
        IN_PROCESS: "Йде призначення відповідальної особи зі сторони НСЗУ",
        APPROVED: "Договір підтверджений",
        DECLINED: "Договір відхилено зі сторони НСЗУ",
        PENDING_NHS_SIGN: "Очікується підписання договору зі строни НСЗУ",
        NHS_SIGNED: "Договір підписаний відповідальною особою зі сторони НСЗУ",
        TERMINATED: "Договір відхилено зі сторони заявника",
        VERIFIED: "Перевірено"
    }

    const contractStatus = (status) => {
        return status ? "Призупинений" : "Діючий";
    }

    return (
        <Show className="show-styles" {...props} title={<ContractRequestShowTitle/>} actions={<ContractActions/>}>
            <div style={{ margin: '1em' }}>
                <div className="legal-entity-list-show">
                    <Card style={cardStyle}>
                        <CardContent style={rowStyle}>
                            <Label caption={"ID"}/>
                            <TextField label="ID" source="id"/>
                        </CardContent>
                        <CardContent style={rowStyle}>
                            <Label caption={"Номер договору"}/>
                            <TextField source="contractNumber"  />
                        </CardContent>
                        <CardContent style={rowStyle}>
                            <Label caption={"Тип договору"}/>
                            <FunctionField source="type"
                                           render={record => `Реімбурсація`} />
                        </CardContent>
                        <CardContent style={rowStyle}>
                            <Label caption={"Статус"}/>
                            <FunctionField source="status"
                                           render={record => contractsValues[record.status]} />
                        </CardContent>
                        <CardContent style={rowStyle}>
                            <Label caption={"Мед. програма"}/>
                            <FunctionField source="status"
                                           render={record => {
                                               let result = [];

                                               if (record.medicalPrograms) {
                                                   for (let i = 0; i < record.medicalPrograms.length; i++) {
                                                       result.push(programs[record.medicalPrograms[i]]);
                                                   }
                                               }

                                               return result.length > 0 ? result.join(', ') : '';
                                           }} />
                        </CardContent>
                        {/*<CardContent style={rowStyle}>*/}
                        {/*    <Label caption={"Причина статусу"}/>*/}
                        {/*    <TextField source="contractType" />*/}
                        {/*</CardContent>*/}
                        <CardContent style={rowStyle}>
                            <Label caption={"Місце договору"}/>
                            <TextField source="issueCity"  />
                        </CardContent>
                        <CardContent style={rowStyle}>
                            <Label caption={"Статус активності"}/>
                            <FunctionField source="isSuspended"
                                           render={record => contractStatus(record.isSuspended)} />
                        </CardContent>
                        <CardContent style={rowStyle}>
                            <Label caption={"Дата початку"}/>
                            <DateField source="startDate" options={{ year: 'numeric', month: 'long', day: 'numeric' }} />
                        </CardContent>
                        <CardContent style={rowStyle}>
                            <Label caption={"Дата закінчення"}/>
                            <DateField source="endDate" options={{ year: 'numeric', month: 'long', day: 'numeric' }} />
                        </CardContent>
                    </Card>
                        {/*<Typography variant="h6" style={{marginBottom: '0.5em'}}>Підрядник - юридична особа</Typography>*/}
                        {/*<CardContent style={rowStyle}>*/}
                        {/*    <Label caption={"Повне офіційне найменування юридичної особи"}/>*/}
                        {/*    <TextField source="contractorLegalEntity.name" />*/}
                        {/*</CardContent>*/}
                        {/*<CardContent style={rowStyle}>*/}
                        {/*    <Label caption={"Код ЄДРПОУ"}/>*/}
                        {/*    <TextField source="contractorLegalEntity.edrpou" />*/}
                        {/*</CardContent>*/}
                        {/*<Typography variant="h8" style={{marginBottom: '0.5em'}}>Адреса юридичної особи</Typography>*/}
                        {/*<CardContent style={rowStyle}>*/}
                        {/*    <Label caption={"Резидентність"}/>*/}
                        {/*    <TextField source="contractorLegalEntity.addresses[0].type"  />*/}
                        {/*</CardContent>*/}
                        {/*<CardContent style={rowStyle}>*/}
                        {/*    <Label caption={"Область"}/>*/}
                        {/*    <TextField source="contractorLegalEntity.addresses[0].area"  />*/}
                        {/*</CardContent>*/}
                        {/*<CardContent style={rowStyle}>*/}
                        {/*    <Label caption={"Район"}/>*/}
                        {/*    <TextField source="contractorLegalEntity.addresses[0].region"  />*/}
                        {/*</CardContent>*/}
                        {/*<CardContent style={rowStyle}>*/}
                        {/*    <Label caption={"Населений пункт"}/>*/}
                        {/*    <TextField source="contractorLegalEntity.addresses[0].settlement"  />*/}
                        {/*</CardContent>*/}
                        {/*<CardContent style={rowStyle}>*/}
                        {/*    <Label caption={"Тип населеного пункту"}/>*/}
                        {/*    <TextField source="contractorLegalEntity.addresses[0].settlementType"  />*/}
                        {/*</CardContent>*/}
                        {/*<CardContent style={rowStyle}>*/}
                        {/*    <Label caption={"Id населеного пункту"}/>*/}
                        {/*    <TextField source="contractorLegalEntity.addresses[0].settlementId"  />*/}
                        {/*</CardContent>*/}
                        {/*<CardContent style={rowStyle}>*/}
                        {/*    <Label caption={"Тип вулиці"}/>*/}
                        {/*    <TextField source="contractorLegalEntity.addresses[0].streetType"  />*/}
                        {/*</CardContent>*/}
                        {/*<CardContent style={rowStyle}>*/}
                        {/*    <Label caption={"Вулиця"}/>*/}
                        {/*    <FunctionField*/}
                        {/*        render={record => `${record.contractorLegalEntity.addresses[0].streetType} ${record.contractorLegalEntity.addresses[0].building} ${record.contractorLegalEntity.addresses[0].apartment}`} />*/}
                        {/*</CardContent>*/}
                        {/*<CardContent style={rowStyle}>*/}
                        {/*    <Label caption={"Поштовий індекс"}/>*/}
                        {/*    <TextField source="contractorLegalEntity.addresses[0].zip"  />*/}
                        {/*</CardContent>*/}
                <Card style={cardStyle}>
                        <Typography variant="h8" style={{marginBottom: '0.5em'}}>Власник підрядника</Typography>
                        <CardContent style={rowStyle}>
                            <Label caption={"Прізвище"}/>
                            <TextField source="contractorOwner.party.lastName"  />
                        </CardContent>
                        <CardContent style={rowStyle}>
                            <Label caption={"Ім'я"}/>
                            <TextField source="contractorOwner.party.firstName"  />
                        </CardContent>
                        <CardContent style={rowStyle}>
                            <Label caption={"По батькові"}/>
                            <TextField source="contractorOwner.party.secondName"  />
                        </CardContent>
                        <CardContent style={rowStyle}>
                            <Label caption={"Підстава підписання договору"}/>
                            <TextField source="contractorBase"  />
                        </CardContent>

                        {/*<Typography variant="h8" style={{marginBottom: '0.5em'}}>Реквізити оплати підрядника</Typography>*/}
                        {/*<CardContent style={rowStyle}>*/}
                        {/*    <Label caption={"Назва банку"}/>*/}
                        {/*    <TextField source="contractorPaymentDetails.bankName"  />*/}
                        {/*</CardContent>*/}
                        {/*<CardContent style={rowStyle}>*/}
                        {/*    <Label caption={"МФО"}/>*/}
                        {/*    <TextField source="contractorPaymentDetails.MFO"  />*/}
                        {/*</CardContent>*/}
                        {/*<CardContent style={rowStyle}>*/}
                        {/*    <Label caption={"Розрахунковий рахунок"}/>*/}
                        {/*    <TextField source="contractorPaymentDetails.payerAccount"  />*/}
                        {/*</CardContent>*/}
                        <CardContent style={rowStyle}>
                            <Label caption={"Повноваження"}/>
                            <TextField source="nhsSignerBase"  />
                        </CardContent>
                        {/*<CardContent style={rowStyle}>*/}
                        {/*    <Label caption={"Спосіб оплати за договором"}/>*/}
                        {/*    <TextField source="nhsPaymentMethod"  />*/}
                        {/*    <FunctionField*/}
                        {/*        render={record => `${paymentMethod[record.nhsPaymentMethod]}`} />*/}
                        {/*</CardContent>*/}
                    </Card>
                    <Card style={cardStyle}>
                        <Typography variant="h6" style={{marginBottom: '0.5em'}}>Юридична особа</Typography>
                        <CardContent style={rowStyle}>
                            <Label caption={"Повне офіційне найменування юридичної особи"}/>
                            <TextField source="nhsLegalEntity.name" />
                        </CardContent>
                        <CardContent style={rowStyle}>
                            <Label caption={"Код ЄДРПОУ"}/>
                            <TextField source="nhsLegalEntity.edrpou" />
                        </CardContent>
                    </Card>
                        {/*<Typography variant="h8" style={{marginBottom: '0.5em'}}>Адреса юридичної особи</Typography>*/}
                        {/*<CardContent style={rowStyle}>*/}
                        {/*    <Label caption={"Резидентність"}/>*/}
                        {/*    <TextField source="nhsLegalEntity.addresses[0].type"  />*/}
                        {/*</CardContent>*/}
                        {/*<CardContent style={rowStyle}>*/}
                        {/*    <Label caption={"Область"}/>*/}
                        {/*    <TextField source="nhsLegalEntity.addresses[0].area"  />*/}
                        {/*</CardContent>*/}
                        {/*<CardContent style={rowStyle}>*/}
                        {/*    <Label caption={"Район"}/>*/}
                        {/*    <TextField source="nhsLegalEntity.addresses[0].region"  />*/}
                        {/*</CardContent>*/}
                        {/*<CardContent style={rowStyle}>*/}
                        {/*    <Label caption={"Населений пункт"}/>*/}
                        {/*    <TextField source="nhsLegalEntity.addresses[0].settlement"  />*/}
                        {/*</CardContent>*/}
                        {/*<CardContent style={rowStyle}>*/}
                        {/*    <Label caption={"Тип населеного пункту"}/>*/}
                        {/*    <TextField source="nhsLegalEntity.addresses[0].settlementType"  />*/}
                        {/*</CardContent>*/}
                        {/*<CardContent style={rowStyle}>*/}
                        {/*    <Label caption={"Id населеного пункту"}/>*/}
                        {/*    <TextField source="nhsLegalEntity.addresses[0].settlementId"  />*/}
                        {/*</CardContent>*/}
                        {/*<CardContent style={rowStyle}>*/}
                        {/*    <Label caption={"Тип вулиці"}/>*/}
                        {/*    <TextField source="nhsLegalEntity.addresses[0].streetType"  />*/}
                        {/*</CardContent>*/}
                        {/*<CardContent style={rowStyle}>*/}
                        {/*    <Label caption={"Вулиця"}/>*/}
                        {/*    <FunctionField*/}
                        {/*        render={record => `${record.nhsLegalEntity.addresses[0].streetType} ${record.nhsLegalEntity.addresses[0].building} ${record.nhsLegalEntity.addresses[0].apartment}`} />*/}
                        {/*</CardContent>*/}
                        {/*<CardContent style={rowStyle}>*/}
                        {/*    <Label caption={"Поштовий індекс"}/>*/}
                        {/*    <TextField source="nhsLegalEntity.addresses[0].zip"  />*/}
                        {/*</CardContent>*/}
                    <Card style={cardStyle}>
                        <Typography variant="h8" style={{marginBottom: '0.5em'}}>Підписант</Typography>
                        <CardContent style={rowStyle}>
                            <Label caption={"Прізвище"}/>
                            <TextField source="nhsSigner.party.lastName"  />
                        </CardContent>
                        <CardContent style={rowStyle}>
                            <Label caption={"Ім'я"}/>
                            <TextField source="nhsSigner.party.firstName"  />
                        </CardContent>
                        <CardContent style={rowStyle}>
                            <Label caption={"По батькові"}/>
                            <TextField source="nhsSigner.party.secondName"  />
                        </CardContent>
                    </Card>
                </div>
            </div>
        </Show>
    );
};

export default ContractRequestShow;
